import React, { useEffect } from 'react';
import { usePreload, usePreloadAPI, usePreloadImages } from '../hooks/usePreload';

interface ResourcePreloaderProps {
  // Critical API endpoints to preload
  apiEndpoints?: string[];
  // Critical images to preload
  images?: string[];
  // Critical fonts to preload
  fonts?: string[];
}

export const ResourcePreloader: React.FC<ResourcePreloaderProps> = ({
  apiEndpoints = [],
  images = [],
  fonts = []
}) => {
  // Preload critical API endpoints
  usePreloadAPI(apiEndpoints);

  // Preload critical images
  usePreloadImages(images);

  // Preload critical fonts (only if not already preloaded in HTML)
  usePreload([
    ...fonts.map(font => ({
      href: font,
      as: 'font' as const,
      type: 'font/woff2',
      crossOrigin: 'anonymous' as const
    }))
  ]);

  return null; // This component doesn't render anything
};

// Default preloader for the main app
export const AppResourcePreloader: React.FC = () => {
  return (
    <ResourcePreloader
      apiEndpoints={[
        // Removed duplicate endpoints - they're handled by React Query in components
        // '/api/statistics/published',    // Handled by NewsLayout
        // '/api/statistics/featured',     // Handled by NewsLayout  
        // '/api/statistics/trending/latest', // Handled by NewsLayout
        // '/api/auth/user'                // Handled by useAuth hook
      ]}
      images={[
        '/images/logo-complete.png',
        '/images/hero-bg.jpg'
      ]}
      fonts={[
        // Only preload fonts that are not already preloaded in HTML
        // Inter 400 and 600 are already preloaded in index.html
      ]}
    />
  );
};
